import React, { useState, useEffect } from "react";
import { useSearchQuery, useEffectOnce } from "hooks";
import { GetFieldsList, Loading } from "components/Utils";
import {
  DataSourceByQueryType,
  QueryFields,
  DataSourceLabel,
} from "data/Types";
import {
  Button,
  ButtonGroup,
  Input,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import styles from "./AdvancedFilters.module.css";

const DataSourceFilter = ({ queryType, field, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => setIsOpen(!isOpen);
  return (
    <ButtonDropdown
      className={styles.dropdown}
      toggle={handleToggle}
      isOpen={isOpen}
    >
      <DropdownToggle caret color="outline-secondary" size="sm">
        {(value && DataSourceLabel[value]) ||
          (value && setImmediate(() => onChange(field, ""))) ||
          "All"}
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem onClick={() => onChange(field, "")}>All</DropdownItem>
        {DataSourceByQueryType[queryType].map((dataSource) => (
          <DropdownItem
            key={dataSource}
            onClick={() => onChange(field, dataSource)}
          >
            {DataSourceLabel[dataSource]}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

const AdvancedFilters = () => {
  const [query, setQuery] = useSearchQuery(false);
  const [advancedQuery, setAdvancedQuery] = useState(null);
  const [logicalOperator, setLogicalOperator] = useState("AND");
  const availableFields = GetFieldsList(QueryFields[query.type], false);
  useEffectOnce(() => {
    const basicQuery = { ...query };
    const initialAdvancedQuery = {};
    basicQuery.isAdvanced = false;
    let q;
    const re = /(\w+\.?\w*):\(([^)]*)\)/gi;
    const foundFields = [...query.query.matchAll(re)];
    // Is the query string already in Advanced syntax, e.g. saved queries?
    if (foundFields.length > 0) {
      q = query.query;
      basicQuery.query = "";
      const re = /(\w+\.?\w*):\(([^)]*)\)/gi;
      const foundFields = [...query.query.matchAll(re)];
      basicQuery.query = [
        ...new Set(
          foundFields.map((match) => {
            initialAdvancedQuery[match[1]] = match[2];
            const field = availableFields.find((f) => f.name === match[1]);
            basicQuery.fields |= QueryFields[field.key];
            return match[2];
          })
        ),
      ].join(" +");
    } else {
      q = availableFields
        .filter((field) => !!(query.fields & QueryFields[field.key]))
        .map((field) => {
          initialAdvancedQuery[field.name] = query.query;
          return `${field.name}:(${query.query})`;
        })
        .join(` ${logicalOperator} `);
    }
    setQuery({ query: q, fields: QueryFields.None, isAdvanced: true });
    setAdvancedQuery(initialAdvancedQuery);
    return () => setQuery(basicQuery);
  });
  useEffect(() => {
    if (advancedQuery != null) {
      const q = Object.keys(advancedQuery)
        .filter(
          (name) => advancedQuery[name] != null && advancedQuery[name] !== ""
        )
        .map((name) => `${name}:(${advancedQuery[name]})`)
        .join(` ${logicalOperator} `);
      setQuery({ query: q });
    }
  }, [advancedQuery, logicalOperator, setQuery]);
  const toggleLogicalOperator = (e) =>
    e.target.blur() ||
    setLogicalOperator(logicalOperator === "AND" ? "OR" : "AND");
  const handleAdvancedQueryChange = (field, value) =>
    setAdvancedQuery({ ...advancedQuery, [field.name]: value });
  if (advancedQuery == null) {
    return <Loading />;
  }
  return (
    <dl>
      <dt>Logical Operator:</dt>
      <dd>
        <ButtonGroup>
          <Button
            onClick={toggleLogicalOperator}
            active={logicalOperator === "AND"}
            size="sm"
          >
            AND
          </Button>
          <Button
            onClick={toggleLogicalOperator}
            active={logicalOperator === "OR"}
            size="sm"
          >
            OR
          </Button>
        </ButtonGroup>
      </dd>
      {availableFields.map((field) => {
        switch (field.key) {
          case "DataSource":
            return (
              <React.Fragment key={field.key}>
                <dt>{field.label}:</dt>
                <dd>
                  <DataSourceFilter
                    queryType={query.type}
                    value={advancedQuery[field.name]}
                    field={field}
                    onChange={handleAdvancedQueryChange}
                  />
                </dd>
              </React.Fragment>
            );
          /*case "Date":
            return (
              <>
                <dt key={field.key}>{field.label}:</dt>
                <dd key={`${field.key}-controls`}>
                  <Input
                    size="sm"
                    type="date"
                    name={field.name}
                    onChange={(e) =>
                      handleAdvancedQueryChange(field, e.target.value)
                    }
                    value={advancedQuery[field.name]}
                  />
                </dd>
              </>
            );/**/
          default:
            return (
              <React.Fragment key={field.key}>
                <dt>{field.label}:</dt>
                <dd>
                  <Input
                    bsSize="sm"
                    name={field.name}
                    onChange={(e) =>
                      handleAdvancedQueryChange(field, e.target.value)
                    }
                    value={advancedQuery[field.name]}
                  />
                </dd>
              </React.Fragment>
            );
        }
      })}
    </dl>
  );
};

export { AdvancedFilters };
